var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYandexAlisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 33C9.7157 33 3 26.2843 3 18C3 9.7157 9.7157 3 18 3C26.2843 3 33 9.7157 33 18C33 26.2843 26.2843 33 18 33ZM11.1315 22.8412C12.2082 23.9127 15.0768 24.5562 18 24.5675C20.9232 24.5562 23.7918 23.9128 24.8685 22.8412C27.544 20.1789 21.0405 9.9795 18.0032 9.9647C14.9595 9.9794 8.456 20.1789 11.1315 22.8412Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -10,
    y1: 10,
    x2: 2,
    y2: -2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C926FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A26FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandexAlisa);
export default __webpack_public_path__ + "static/media/yandexAlisa.4de9281b.svg";
export { ForwardRef as ReactComponent };